import { CitySchema } from "@/components/_Shared/Form/Schemas/CitySchema";
import { ClientSchema } from "@/components/_Shared/Form/Schemas/ClientSchema";
import { ContactSchema } from "@/components/_Shared/Form/Schemas/ContactSchema";
import { DateDueSchema } from "@/components/_Shared/Form/Schemas/DateDueSchema";
import { DatesSchema } from "@/components/_Shared/Form/Schemas/DatesSchema";
import { DescriptionSchema } from "@/components/_Shared/Form/Schemas/DescriptionSchema";
import { ManagerSchema } from "@/components/_Shared/Form/Schemas/ManagerSchema";
import { ProjectNameSchema } from "@/components/_Shared/Form/Schemas/ProjectName";
import { ProjectStatusSchema } from "@/components/_Shared/Form/Schemas/StatusSchema";
import { TemplateSchema } from "@/components/_Shared/Form/Schemas/TemplateSchema";
import { z } from "zod";

// Main project form schema that combines all the above schemas
export const ProjectFormSchema = z.object ({
    no_date_due: z.boolean().optional(),
    consulting_fee: z.coerce.number().optional(),
    project_size: z.union([
        z.number(),
        z.string().refine(val => !isNaN(Number(val)), {
            message: "Please enter a valid number"
        }).transform(val => Number(val))
    ]).optional(),
    isDeadline: z.boolean(),
    folder_location: z.string().optional(),
    construction_admin_services: z.object({
        value: z.enum(["No", "Yes", "Completed"]),
        label: z.string(),
    }),
})
    .merge(ProjectNameSchema)
    .merge(DatesSchema)
    .merge(ProjectStatusSchema)
    .merge(ManagerSchema)
    .merge(CitySchema)
    .merge(DescriptionSchema)
    .merge(ClientSchema)
    .merge(ContactSchema)
    .merge(TemplateSchema)
    .merge(DateDueSchema)
    .refine(
        (data) => {
            // If isDeadline is true, then end_date must be provided
            if (data.isDeadline === true) {
                return data.end_date !== undefined && data.end_date !== null && data.end_date !== '';
            }
            return true
        },
        {
            message: "Date due is required when deadline is enabled",
            path: ["end_date"]
        }
    )

